import { Badge, TabSwitch, Text, HStack, VStack } from '@genial/components';
import { BoxRadius, Spacing, Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { Box } from 'native-base';
import React from 'react';

import { ContainerWrapper } from '../../../..';
import { BatchTicketResumeDetailTypeParam } from '../../../../../../routes/types';
import { useBatchTicketResume } from '../../../../hooks';
import { Footer } from '../../../Footer';
import { Header } from '../../../Header';
import { BasketInfoResume } from '../BasketInfoResume';
import { SendingChannel } from '../SendingChannel';

interface MainContainerProps {}

export const MainContainer: React.FC<MainContainerProps> = () => {
  const isDesktop = useBreakpointValue({ base: false, sm: true });
  const isMobile = useBreakpointValue({ base: true, sm: false });
  const {
    actionButtonIsDisabled,
    actionButtonTitle,
    cancelButtonIsDisabled,
    handleAction,
    handleCancel,
    onTabPress,
    selectedTab,
    selectedTabIsSummary,
    tabs,
    onChannelSelectChange,
    sendingChannelsOptions,
    sendingChannelsSelected,
    isManager,
  } = useBatchTicketResume();
  return (
    <VStack space={Spacing['inline.xxs']} flex={1}>
      <ContainerWrapper>
        <Header cancelButtonIsDisabled={cancelButtonIsDisabled} handleCancelButton={handleCancel} />
        <VStack
          w="full"
          bg={{ base: 'transparent', sm: 'neutral.white' }}
          borderTopRadius={BoxRadius.sm}
          pb={{ sm: Spacing['inline.xxs'] }}
          flex={1}
          space={Spacing['inline.xxs']}>
          {isDesktop && (
            <VStack
              p={{ sm: Spacing['stack.xxs'] }}
              borderBottomWidth={{ sm: '1px' }}
              borderBottomColor="neutral.light">
              <HStack alignItems="center" justifyContent="space-between">
                <Text
                  fontSize={Typography['fontsize.lg']}
                  variant="semibold"
                  color="brand.primary.principal">
                  Personalize a boleta
                </Text>
                <Badge
                  testId="badge-resume-batch-ticket"
                  backgroundColor="feedback.success.default"
                  textColor="neutral.white">
                  Concluído
                </Badge>
              </HStack>
            </VStack>
          )}
          <BasketInfoResume />
          <Box px={{ base: 0, sm: Spacing['inline.xxs'] }} w={'full'}>
            <TabSwitch
              testId="tab-switch"
              tabs={tabs}
              selectedTab={selectedTab}
              onTabPress={(value) => onTabPress(value as BatchTicketResumeDetailTypeParam)}
              isMobile={isMobile}
              isLoading={false}
            />
          </Box>
        </VStack>
        {!isManager && selectedTabIsSummary && (
          <SendingChannel
            sendingChannelsOptions={sendingChannelsOptions}
            onChannelSelectChange={onChannelSelectChange}
            sendingChannelsSelected={sendingChannelsSelected}
          />
        )}
      </ContainerWrapper>
      <Footer
        variant="resume"
        hasSendButton
        actionButtonTitle={actionButtonTitle}
        actionButtonIsDisabled={actionButtonIsDisabled}
        cancelButtonIsDisabled={cancelButtonIsDisabled}
        handleCancelButton={handleCancel}
        handleActionButton={handleAction}
      />
    </VStack>
  );
};
